import React from 'react';
import Form from 'react-bootstrap/Form';

interface DefaultValueCheckboxProps {
    className?: string;
    defaultChecked?: boolean;
    name: string;
    values?: {
        checked: string;
        unchecked: string;
    };
}

/**
 * If a regular checkbox is unchecked when its form is submitted, there is no value submitted to the server to
 * represent its unchecked state (e.g. value=unchecked); the value is not submitted to the server at all. This version
 * submits a default value for the checkbox when it is unchecked by including an <input type="hidden"> inside the form
 * with the same name and a default value for the unchecked state. The hidden input is disabled when the checkbox is
 * checked, and enabled when the checkbox is unchecked, so that only one value is ever sent.
 */
const DefaultValueCheckbox: React.FC<DefaultValueCheckboxProps> = ({ className, defaultChecked, name, values }) => {
    const hiddenInput = React.useRef<HTMLInputElement>(null);

    return (
        <>
            <Form.Check.Input
                className={className}
                defaultChecked={defaultChecked}
                name={name}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (hiddenInput.current) {
                        hiddenInput.current.disabled = event.currentTarget.checked;
                    }
                }}
                //readOnly doesn't prevent toggling checkboxes
                value={values?.checked ?? '1'}
            />
            <input
                disabled={defaultChecked}
                name={name}
                ref={hiddenInput}
                type="hidden"
                value={values?.unchecked ?? '0'}
            />
        </>
    );
};

export { DefaultValueCheckbox };
